import React from 'react';
import MainElder from './mainElder.jsx';

const Index = () => {

	return(

		<MainElder />

	)

}

export default Index;